import { createSlice, PayloadAction } from '@reduxjs/toolkit';

enum AppStatus {
  NO_DOCUMENT = 'NO_DOCUMENT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  EDITING = 'EDITING'
}

export interface OcrDataPage {
  pageNumber: number;
  text: string;
  image: string | undefined;
  isLoading: boolean;
}

export interface OcrData {
  selectedPage: number | undefined;
  pages: OcrDataPage[];
  lastOcrTemplatePage: number | undefined;
}

export interface BarcodeDataCopyItem {
  fieldKey: string;
  fieldValue: string;
  fieldInputValue: string;
}

export interface BarcodeDataCopy {
  doctypeKey: string | null;
  doctypeTitle: string | null;
  fields: BarcodeDataCopyItem[];
}

interface AppState {
  status: AppStatus;
  pdfFileURI: string;
  currentPage: number | null;
  displayNavigator: boolean;
  copiedBarcode: BarcodeDataCopy | null;
  ocrData: OcrData | null;
}

const initialState: AppState = {
  status: AppStatus.NO_DOCUMENT,
  pdfFileURI: '',
  currentPage: null,
  displayNavigator: false,
  copiedBarcode: null,
  ocrData: null
};

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setStatus(state, action: PayloadAction<AppStatus>) {
      state.status = action.payload;
    },
    setPdfFileURI(state, action: PayloadAction<string>) {
      state.pdfFileURI = action.payload;
    },
    setCurrentPage(state, action: PayloadAction<number | null>) {
      state.currentPage = action.payload;
    },
    setDisplayNavigator(state, action: PayloadAction<boolean>) {
      state.displayNavigator = action.payload;
    },
    setCopiedBarcode(state, action: PayloadAction<BarcodeDataCopy | null>) {
      state.copiedBarcode = action.payload;
    },
    setOcrData(state, action: PayloadAction<OcrData | null>) {
      state.ocrData = action.payload;
    }
  }
});

export const {
  setStatus,
  setPdfFileURI,
  setCurrentPage,
  setDisplayNavigator,
  setCopiedBarcode,
  setOcrData
} = appStateSlice.actions;

export default appStateSlice.reducer;

export { AppStatus };
